import React from 'react';
import { FloatButton, Popover, Row, Space, Typography, Button } from 'antd';
import { LinkOutlined, QuestionCircleOutlined, SendOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { config } from '@/config/index.js';
import FeedbackModal from './feedbackModal.js';
import { setIsShowFeedback, setIsShowSystemTour } from '@/store/modules/chatSlice.js';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const BASE_URL = config.SCAMS_REPORT_ASSETS_BASE_URL;

const data = [
  {
    key: 'whatIs',
    url: `${BASE_URL}/policy/what_is_scams_report.pdf`,
  },
  {
    key: 'privacyNotice',
    url: `${BASE_URL}/policy/privacy-collection-notice.pdf`,
  },
  {
    key: 'terms',
    url: `${BASE_URL}/policy/terms-of-use.pdf`,
  },
  {
    key: 'privacyPolicy',
    url: `${BASE_URL}/policy/privacy-policy.pdf`,
  },
];

const QuestionCenter = props => {
  const { isMobile, renderAsButton } = props;
  const dispatch = useDispatch();
  const { isShowFeedback } = useSelector(state => state.chat);
  const { t } = useTranslation(['feedback']);

  const showFeedbackModal = () => {
    dispatch(setIsShowFeedback(true));
  };

  const showSystemTourModal = () => {
    dispatch(setIsShowSystemTour(true));
  };

  const renderContent = () => {
    return (
      <Space direction="vertical" style={{ padding: '.3rem .5rem' }}>
        {data.map(item => {
          return (
            <Row key={item.key} style={{ margin: '0.1rem 0' }}>
              <Link to={item.url} target="_blank">
                <Space>
                  <LinkOutlined />
                  <Text>{t(`feedback:popover.${item.key}`)}</Text>
                </Space>
              </Link>
            </Row>
          );
        })}
        <Row style={{ margin: '0.1rem 0', cursor: 'pointer' }} onClick={showFeedbackModal}>
          <Space>
            <QuestionCircleOutlined />
            <Text>{t('feedback:popover.commentsAndFeedback')}</Text>
          </Space>
        </Row>
        <Row style={{ margin: '0.1rem 0', cursor: 'pointer' }} onClick={showSystemTourModal}>
          <Space>
            <SendOutlined />
            <Text>{t('feedback:popover.systemTour')}</Text>
          </Space>
        </Row>
      </Space>
    );
  };

  return (
    <>
      <Popover content={renderContent()} arrow={false} placement="bottomLeft">
        {renderAsButton ? (
          <Button type="link" ghost icon={<QuestionCircleOutlined />} />
        ) : (
          <FloatButton
            icon={<QuestionCircleOutlined />}
            type="default"
            style={{ insetInlineEnd: '3vw', bottom: isMobile ? '10vh' : '2.8vh' }}
          />
        )}
      </Popover>
      {isShowFeedback && <FeedbackModal typeModal="QuestionCenter" />}
    </>
  );
};

export default QuestionCenter;
